const PLATFORMS = {
   filmmakers: {
      src:   (id) => `${id}?autoplay=false&background_color=none&iframe=v2&playlist=h`,
      allow: 'autoplay; fullscreen',
   },
   vimeo: {
      src:   (id) => `https://player.vimeo.com/video/${id}?dnt=1`,
      allow: 'autoplay; fullscreen; picture-in-picture',
   },
   youtube: {
      src:   (id) => `https://www.youtube.com/embed/${id}`,
      allow: 'autoplay; fullscreen; picture-in-picture',
   },
};

const CONSENT_KEY = 'cookie_consent';

function hasConsent() {
   return localStorage.getItem(CONSENT_KEY) === 'accepted';
}

function createVideoPlaceholder(container) {
   container.classList.add('video-player--blocked');
   container.innerHTML = `
      <div class="video-consent-placeholder">
         <p class="video-consent-placeholder__text">This video requires cookies. Please accept cookies to watch.</p>
         <button class="video-consent-placeholder__accept" type="button">Accept cookies</button>
      </div>
   `;
   container.querySelector('.video-consent-placeholder__accept').addEventListener('click', () => {
      localStorage.setItem(CONSENT_KEY, 'accepted');
      const banner = document.getElementById('cookie-consent');
      if (banner) banner.classList.remove('is-visible');
      unlockVideoPlayers();
   });
}

/**
 * Creates a video player iframe inside the given container element.
 * @param {HTMLElement} container
 * @param {string} platform  - 'filmmakers' | 'vimeo' | 'youtube'
 * @param {string} id        - platform video ID
 */
export function createVideoPlayer(container, platform, id) {
   const config = PLATFORMS[platform];
   if (!config || !id) {
      console.warn('[video-player] unknown platform or missing id', { platform, id });
      return;
   }

   const iframe = document.createElement('iframe');
   iframe.src = config.src(id);
   iframe.allow = config.allow;
   iframe.allowFullscreen = true;
   iframe.loading = 'lazy';
   iframe.style.cssText = 'border:0;position:absolute;top:0;right:0;left:0;bottom:0;height:100%;width:100%;';

   container.innerHTML = '';
   container.appendChild(iframe);
   console.log('[video-player] injected iframe', iframe);
}

/**
 * Replaces all blocked placeholders with actual video players.
 * Called when the user accepts cookies.
 */
export function unlockVideoPlayers() {
   document.querySelectorAll('.video-player--blocked').forEach((el) => {
      el.classList.remove('video-player--blocked');
      createVideoPlayer(el, el.dataset.videoPlatform, el.dataset.videoId);
   });
}

/**
 * Finds all [data-video-platform][data-video-id] elements in the DOM
 * (or within a root element) and instantiates players for each.
 * @param {HTMLElement|Document} root
 */
export function initVideoPlayers(root = document) {
   root.querySelectorAll('[data-video-platform][data-video-id]').forEach((el) => {
      if (hasConsent()) {
         createVideoPlayer(el, el.dataset.videoPlatform, el.dataset.videoId);
      } else {
         createVideoPlaceholder(el);
      }
   });
}
